export default __webpack_public_path__ + "static/cs-deloitte--mobile-e5983529fb22cfd32c18530c2752e257.webp";